import styled from 'styled-components';

import { ShareArrowUpIcon } from '@assets/icons/ShareArrowUp';
import { UnstyledButton } from '@components/UnstyledButton/UnstyledButton';

type ShareApplicationButtonProps = {
  onShareButtonClick: () => void;
};

export const ShareApplicationButton = ({
  onShareButtonClick,
}: ShareApplicationButtonProps) => {
  return (
    <StyledShareButton onClick={onShareButtonClick}>
      <div className='icon-container'>
        <ShareArrowUpIcon />
      </div>
      <div className='button-text'>Share</div>
    </StyledShareButton>
  );
};

const StyledShareButton = styled(UnstyledButton)`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  padding: 6px 12px 6px 8px;

  @media (max-width: 768px) {
    padding: 8px 16px 8px 12px;
  }

  .icon-container {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;

    @media (max-width: 768px) {
      width: 24px;
      height: 24px;

      svg {
        width: 18px;
        height: auto;
      }
    }
  }
  .button-text {
    font-size: 14px;
    line-height: 20px;
    font-weight: 600;
  }
`;
